import React from 'react';
import { CheckCircle2, ShieldCheck } from 'lucide-react';

/**
 * Credential badge surfaced on marketplace cards & public clinician profiles.
 *  - verified_specialist     → clinical credibility (verified + declared focus)
 *  - advanced_clinical_scope → high-demand / specialized credentials
 * Backend supplies these via clinician.badges (server._clinician_badges).
 */
const VARIANTS = {
  verified_specialist: {
    label: 'Verified Specialist',
    Icon: CheckCircle2,
    cls: 'bg-cn-primary/10 text-cn-primary border-cn-primary/20',
  },
  advanced_clinical_scope: {
    label: 'Advanced Clinical Scope',
    Icon: ShieldCheck,
    cls: 'bg-cn-terracotta-50 text-cn-terracotta-700 border-cn-terracotta-200',
  },
};

export const SpecialtyBadge = ({ variant, className = '' }) => {
  const v = VARIANTS[variant];
  if (!v) return null;
  const { label, Icon, cls } = v;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border font-mono text-[10px] uppercase tracking-wide leading-none ${cls} ${className}`}
      data-testid={`specialty-badge-${variant}`}
    >
      <Icon className="w-3 h-3 flex-shrink-0" /> {label}
    </span>
  );
};

/** Render all badges from a clinician's `badges` array. */
export const SpecialtyBadgeRow = ({ badges, className = '' }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="specialty-badge-row">
      {badges.map((b) => <SpecialtyBadge key={b} variant={b} />)}
    </div>
  );
};

export default SpecialtyBadge;
